// TODO: AX-3815 update type for creatives in useAssetId

import { useQuery } from '@apollo/client';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

import type { GetAsset2ByIdQuery, GetAsset2ByIdQueryVariables } from '../../../../apis/graphql';
import type { Asset2, Asset2GQL, Nullable } from '../../../../models';
import { transformAsset2GQLToAsset2 } from '../../../../utils/assets';
import { getAdCountryListForReview } from '../../../../utils/reviewDerivation';
import type { AdFormValues } from '../../adFormik';
import { GET_ASSET_2_BY_ID } from '../../hooks/queries';

export type UseGetAssetByIDResult = {
  asset: Asset2 | null;
  loading: boolean;
  fetchAssetById(assetID: string): Promise<Asset2>;
};

const useGetAssetById = (assetID?: string, lineItemPublisherList?: Nullable<string[]>): UseGetAssetByIDResult => {
  const { values } = useFormikContext<AdFormValues>();
  const countryList = useMemo(
    () => getAdCountryListForReview(values.lineItem?.countries, values.targetingTermValues ?? []),
    [values.lineItem?.countries, values.targetingTermValues]
  );

  const { data, loading, refetch } = useQuery<GetAsset2ByIdQuery, GetAsset2ByIdQueryVariables>(GET_ASSET_2_BY_ID, {
    variables: {
      assetID: assetID ?? '',
    },
    skip: !assetID,
  });

  const assetRaw = data?.getAsset2ByID as Asset2GQL;

  const asset = assetRaw ? transformAsset2GQLToAsset2(assetRaw, lineItemPublisherList, countryList) : null;

  const fetchAssetById = async (assetId?: string): Promise<Asset2> => {
    const { data } = await refetch({
      assetID: assetId,
    });

    const raw = data.getAsset2ByID as Asset2GQL;

    return transformAsset2GQLToAsset2(raw, lineItemPublisherList, countryList);
  };

  return {
    asset,
    loading,
    fetchAssetById,
  };
};

export default useGetAssetById;
